

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Sagar Singh",
  title: "Hi all, I'm Sagar Singh",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 having an experience of building Web  applications with JavaScript / Reactjs / Nodejs / MongoDB and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1jCWIWI4eJ5T_dNB4N1AdVEwz0bFiCcGg/view?usp=drivesdk",
  displayGreeting: true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/Sagarsingh9528",
  linkedin: "https://www.linkedin.com/in/sagar-singh-632108237/",
  gmail: "sagarsingh33693@gmail.com",


  display: true
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "A FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Built end-to-end web applications using React.js, Node.js, Express.js, and MongoDB"
    ),
    emoji("⚡ Designed scalable REST APIs with proper routing, controllers, and middleware"),
    emoji(
      "⚡ Implemented clean MVC architecture for maintainable backend code"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },

    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },


    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },

    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true
};

// Education Section

const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "Ajay Kumar Garg Engineering College{AKTU}",
      logo: require("./assets/images/AKG.png"),
      subHeader: "Bachelor of Technology in Computer Science",
      duration: "Aug 2023 - July 2027",
      desc: "CGPA: 7",
      descBullets: [

      ]
    }
  ]
};



const techStack = {
  viewSkillBars: true,
  experience: [
    {
      Stack: "Backend{Nodejs, Express, MongoDb}",
      progressPercentage: "80%"
    },
    {
      Stack: "Programming{C++}",
      progressPercentage: "70%"
    },
    {
      Stack: "Frontend{Reactjs}",
      progressPercentage: "100%"
    }
  ],
  displayCodersrank: true
};

// Work experience section

const workExperiences = {
  display: true,
  experience: [
    {
      role: "Full Stack Developer",
      company: "CodeSoft",
      companylogo: require("./assets/images/codeSoft.avif"),
      date: "Sept 2025 – Oct 2025",
      desc: "",
      descBullets: [
        "Gained hands-on experience in full stack development using React, Node.js, Express, MongoDB, including REST APIs, WebSockets, and real-time features during my CodeSoft internship."
      ]
    }

  ]
};



const openSource = {
  showGithubProfile: "true",
  display: true
};



const bigProjects = {
  title: "My Projects",
  subtitle: "",
  display: true,
  projects: [
    {
      image: require("./assets/images/ping.avif"),
      projectName: "Ping(Social Media & Collaboration Platform)",
      projectDesc:
        "Ping is a modern social media web application inspired by platforms like Instagram, designed to help users connect, share, and communicate in real time. ",
      status: "LIVE",
      techStack: [
        { name: "React", icon: "⚛️" },
        { name: "Node.js", icon: "🟢" },
        { name: "Express", icon: "🚀" },
        { name: "MongoDB", icon: "🍃" },
      ],
      highlights: [
        "⚙️ Built secure REST APIs with Node.js, Express.js, and JWT",
        "💬 Added real-time chat & notifications using Socket.io",
        "🎨 Created a responsive UI using React.js",
      ],
      footerLink: [
        {
          name: "🌐Live",
          url: "https://www.linkupofficial.tech/",
        },
        {
          name: "🚀Code",
          url: "https://github.com/Sagarsingh9528/Ping",
        },
      ],
    },

    {
      image: require("./assets/images/blog.avif"),
      projectName: "Blog (Create a Blog platform)",
      projectDesc:
        "Blog is a full-stack web application that allows users to create, publish, and manage blogs seamlessly. The platform supports user authentication, rich text content creation, and category-based blog organization, providing a clean and engaging reading experience for users. ",
      status: "Live",
      techStack: [

        { name: "Node.js", icon: "🟢" },
        { name: "Express", icon: "🚀" },
        { name: "MongoDB", icon: "🍃" },
        { name: "Cloudinary", icon: "☁️" },
      ],
      highlights: [
        "⚙️ Built RESTful APIs using Node.js, Express, and MongoDB",
        "🤖 Integrated AI/ML services for AR monument scan and trip planning",
        "🤝 Implemented community, events, and marketplace features",
      ],
      footerLink: [
        {
          name: "🌐Live",
          url: "https://blog-app-ochre-nine.vercel.app/",
        },
        {
          name: "🚀Code",
          url: "https://github.com/Sagarsingh9528/blog-app",
        },
      ],
    },
  ],
};






const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "VE-Cell SDG 2K24",
      subtitle:
        "Secured 5th rank in the VE-Cell–organized SDG Competition as part of a 3-member team, demonstrating teamwork and innovation 💻🏆",
      image: require("./assets/images/ve cell.png"),
      imageAlt: "VCell  2k24 logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1jV3GaU3_7QUJwkivHAcckJMkuo-UiEc6/view?usp=drivesdk"
        },

      ]
    },
    {
      title: "HACK WITH INDIA 2025",
      subtitle:
        "In recognition of their outstanding performance and achievement, placing among the top 1,000 teams out of 3,000 participating teams in Vibe Hacks 2.0. Their hard work, talent, and dedication throughout the event exemplify their commitment to excellence 🏆✨",
      image: require("./assets/images/hackwithindia.jpg"),
      imageAlt: "hackwithindia Logo",
      footerLink: [
          {
          name: "Certification",
          url: "https://drive.google.com/file/d/147m6PK5KMQL6N5g5C_QT8UiXIjnaPeKH/view?usp=drivesdk"
        },
      ]
    },


  ],
  display: true // Set false to hide this section, defaults to true
};


const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "",
      event_url: ""
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",


  podcast: [
    ""
  ],
  display: false
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",


  display: true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-9027091955",
  email_address: "sagarsingh33693@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "SagarSi64147214",
  display: true
};

const isHireable = true;
export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
